// src/utils/lineDefaults.js
import { getColorsByProductCode } from "../constants/colors";
import { FONTS } from "../constants/fonts";

export const getDefaultLineValues = (selectedProduct) => {
  if (!selectedProduct?.code) {
    return {
      size: "02",
      sizeName: "2 inch",
      color: "black_190",
      colorName: "Black",
      font: "Ubunto",
      text: "",
      price: 0,
      canvasObj: null,
    };
  }

  const sizes = selectedProduct.sizes || [];
  const firstSize = sizes[0] || { code: "02", name: "2 inch" };

  const colors = getColorsByProductCode(selectedProduct.code);
  const firstColor = colors[0] || { code: "black_190", name: "Black" };

  const defaultFont = FONTS[0]?.name || FONTS[0]?.name || "Ubuntu";

  return {
    size: firstSize.code,
    sizeName: firstSize.name,
    color: firstColor.code,
    colorName: firstColor.name,
    font: defaultFont,
    text: "",
    price: 0,
    canvasObj: null,
  };
};
